import { render, staticRenderFns } from "./BxKuncunInfoForm.vue?vue&type=template&id=365393ea&"
import script from "./BxKuncunInfoForm.vue?vue&type=script&lang=js&"
export * from "./BxKuncunInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports